import * as React from "react";
import { ICard } from "./Card";
import { GameDifficulty } from "./Scenario";
import { DeckComponent } from "./DeckComponent";
import { IDeck } from "./Deck";
import { CardUtil } from "./CardUtil";

export interface IScenarioReferenceProps {
    card: ICard;
    difficulty: GameDifficulty;
}
export class ScenarioReferenceComponent extends React.Component<IScenarioReferenceProps, any> {
    render() {
        const card = this.props.card;
        const faceUp = !(this.props.difficulty === GameDifficulty.Hard ||
            this.props.difficulty === GameDifficulty.Expert);
        CardUtil.flipCard(card, faceUp);
        const deck: IDeck = { cards: [card] };
        return (
            <div className="scenario-reference">
                <DeckComponent deck={deck} horizontal={false} settings={{ toolbar: { flip: false } }} />
            </div>
        );
    }
}
